import Testimonial, { TestimonialProps, TestimonialSection } from './Testimonial';

export type { TestimonialProps };
export { TestimonialSection };
export default Testimonial;
